import React from 'react';
import './GoogleMerchantModal.css';

export default function GoogleMerchantModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  const handleShopNow = (e) => {
    e.preventDefault();
    onClose();
    const el = document.getElementById('product-showcase');
    if (el) {
      const promoEl = document.querySelector('.promo-banner, .announcement-bar');
      const promoH = promoEl ? Math.ceil(promoEl.getBoundingClientRect().height) : 0;
      const offset = promoH + 80 + 20;
      const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition, offset,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="google-modal-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <div className="google-modal-card" onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <button className="google-modal-close-btn" onClick={onClose} aria-label="Close Rating Details">
          ✕
        </button>

        {/* Header Badge */}
        <div className="google-modal-header">
          <div className="google-modal-logo-wrap">
            <svg viewBox="0 0 24 24" width="28" height="28">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"/>
            </svg>
          </div>
          <div className="google-modal-title-box">
            <span className="google-modal-badge">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              Google Verified Merchant
            </span>
            <h2 className="google-modal-store-name">iLOVEthisgame.ca</h2>
            <span className="google-modal-subtitle">Official Canadian Playermaker 2.0 Partner</span>
          </div>
        </div>

        {/* Big Score Box */}
        <div className="google-rating-score-box">
          <div className="google-score-big">4.9</div>
          <div className="google-score-meta">
            <div className="google-stars-row">★★★★★</div>
            <div className="google-review-count">Based on 1,240+ Verified Customer Reviews</div>
            <div className="google-trust-pills">
              <span>✓ 100% Authentic Product</span>
              <span>✓ Canadian Fast Shipping</span>
            </div>
          </div>
        </div>

        {/* Star Rating Breakdown */}
        <div className="google-breakdown-section">
          <div className="google-breakdown-title">Customer Satisfaction Breakdown</div>
          
          <div className="google-bar-row">
            <span className="google-bar-label">5 Stars</span>
            <div className="google-bar-track">
              <div className="google-bar-fill" style={{ width: '92%' }}></div>
            </div>
            <span className="google-bar-pct">92%</span>
          </div>

          <div className="google-bar-row">
            <span className="google-bar-label">4 Stars</span>
            <div className="google-bar-track">
              <div className="google-bar-fill" style={{ width: '6%' }}></div>
            </div>
            <span className="google-bar-pct">6%</span>
          </div>

          <div className="google-bar-row">
            <span className="google-bar-label">3 Stars</span>
            <div className="google-bar-track">
              <div className="google-bar-fill" style={{ width: '1%' }}></div>
            </div>
            <span className="google-bar-pct">1%</span>
          </div>

          <div className="google-bar-row">
            <span className="google-bar-label">2 Stars</span>
            <div className="google-bar-track">
              <div className="google-bar-fill" style={{ width: '0.5%' }}></div>
            </div>
            <span className="google-bar-pct">&lt;1%</span>
          </div>

          <div className="google-bar-row">
            <span className="google-bar-label">1 Star</span>
            <div className="google-bar-track">
              <div className="google-bar-fill" style={{ width: '0.5%' }}></div>
            </div>
            <span className="google-bar-pct">&lt;1%</span>
          </div>
        </div>

        {/* Featured Testimonials */}
        <div className="google-reviews-list">
          <div className="google-review-card">
            <div className="google-review-author-row">
              <span className="google-review-author">Mark T., Toronto, ON</span>
              <span className="google-verified-tag">✓ Verified Order</span>
            </div>
            <div className="google-review-stars">★★★★★</div>
            <p className="google-review-text">
              "Best soccer investment I've made for my 14yo son. Tracked kick velocity, touches, and left vs right foot ratio accurately. Fast Canadian shipping!"
            </p>
          </div>

          <div className="google-review-card">
            <div className="google-review-author-row">
              <span className="google-review-author">Sarah L., Vancouver, BC</span>
              <span className="google-verified-tag">✓ Verified Order</span>
            </div>
            <div className="google-review-stars">★★★★★</div>
            <p className="google-review-text">
              "Legit official Playermaker 2.0 kit with Canadian warranty support. Received in 2 business days in BC. Highly recommend iLOVEthisgame!"
            </p>
          </div>
        </div>

        {/* Actions */}
        <div className="google-modal-actions">
          <button onClick={handleShopNow} className="google-modal-buy-btn">
            Shop Playermaker 2.0 Kit &rarr;
          </button>
        </div>
      </div>
    </div>
  );
}
